import React, { useState } from 'react'
import styles from '../Components/Experiences.module.css'
import ExperienceEachWrapper from './ExperienceEachWrapper'
import Collapsible from 'react-collapsible';
// BsBriefcaseFill
import { BsBriefcaseFill } from 'react-icons/bs'

const Experiences = props => {
    const { data } = props
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className={styles.mainWrapper}>
            <Collapsible trigger={
                <div className={isOpen === true ? styles.mainHeaderOpen : styles.mainHeader}>
                    <div className={styles.leftCol}>
                        <BsBriefcaseFill />
                        <span className={styles.headerTitle}>
                            Work Experience
                        </span>
                    </div>
                    <div className={styles.rightCol}>

                    </div>
                </div>
            }
                isOpen={false}
                onOpening={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
            >

                <div className={styles.mainContainer}>
                    {data?.map((item, index) => (
                        <ExperienceEachWrapper
                            vergeType={index===0 ? `north` : ((data?.length - index)===1) ? `south` : `center` }
                            item={item}
                            key={index}
                        />
                    ))}
                </div>
            </Collapsible>
        </div>
    )
}

export default Experiences